{
  "states": {
    "loading": "Caricamento...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "Sereno",
    "Clouds": "Nuvoloso",
    "Rain": "Pioggia",
    "Drizzle": "Pioggerella",
    "Thunderstorm": "Temporale",
    "Snow": "Neve",
    "Mist": "Foschia",
    "Smoke": "Fumo",
    "Haze": "Caligine",
    "Dust": "Polvere",
    "Fog": "Nebbia",
    "Sand": "Sabbia",
    "Ash": "Cenere",
    "Squall": "Raffica",
    "Tornado": "Tornado"
  },
  "modal": {
    "defaultTitle": "Meteo",
    "subtitle": "Condizioni attuali",
    "showFahrenheit_aria": "Mostra Fahrenheit",
    "showCelsius_aria": "Mostra Celsius",
    "switchToCelsius_title": "Passa a °C",
    "switchToFahrenheit_title": "Passa a °F",
    "feelsLike": "Percepita {{temp}}°{{unit}}",
    "humidityWind": "Umidità {{humidity}}% · Vento {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "Ora",
    "hourlyOffset": "{{hours}}h",
    "hourlyStrip_aria": "Temperatura oraria",
    "hourlyLocked": "Le previsioni orarie sono una funzione Pro.",
    "statsLocked": "I dettagli meteo sono una funzione Pro.",
    "stats": {
      "sunrise": "Alba",
      "sunset": "Tramonto",
      "feels": "Percepita",
      "humidity": "Umidità",
      "wind": "Vento",
      "rain": "Pioggia"
    },
    "rainInches": "{{value}} in",
    "forecastTitle": "Previsioni a 5 giorni",
    "forecastLoading": "Caricamento previsioni…",
    "forecastUnavailable": "Previsioni non disponibili",
    "forecastLocked": "Le previsioni a 5 giorni sono una funzione Pro.",
    "forecastRow_aria": "Previsioni a cinque giorni",
    "proHeadline": "Le previsioni complete fanno parte di Pro.",
    "proFeatures": "Ogni ora · Condizioni dettagliate · Previsioni a 5 giorni."
  }
}
